import { Tabs, Typography } from 'antd';
import { ProfileTab } from '@presentation/components/settings/ProfileTab';
import { SecurityTab } from '@presentation/components/settings/SecurityTab';
import { SessionsTab } from '@presentation/components/settings/SessionsTab';
import { PreferencesTab } from '@presentation/components/settings/PreferencesTab';
import { KeyboardShortcutsTab } from '@presentation/components/settings/KeyboardShortcutsTab';

export const SettingsPage = () => {
  return (
    <div className="mx-auto max-w-4xl px-6 py-10">
      <Typography.Title level={3} className="!mb-6">
        Settings
      </Typography.Title>
      <Tabs
        tabPlacement="start"
        items={[
          { key: 'profile', label: 'Profile', children: <ProfileTab /> },
          { key: 'security', label: 'Security', children: <SecurityTab /> },
          { key: 'sessions', label: 'Sessions', children: <SessionsTab /> },
          { key: 'preferences', label: 'Preferences', children: <PreferencesTab /> },
          { key: 'shortcuts', label: 'Keyboard Shortcuts', children: <KeyboardShortcutsTab /> },
        ]}
      />
    </div>
  );
};
